import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';
import { auxiliaryMachines } from '../../mock/mockData';

const PETBottleBlowing = () => {
  const productData = auxiliaryMachines.find(p => p.id === 'pet-blowing');
  return <ProductPageTemplate productData={productData} />;
};

export default PETBottleBlowing;